import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "task-send",
  "use": "task-send-usage",
  "viewBox": "0 0 25.78 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25.78 18\" id=\"task-send\"><path d=\"M13.88 11.23l-1.67-1.66-1-1.21a6 6 0 00.54-2.47A5.89 5.89 0 005.89 0a5.68 5.68 0 00-2.15.41l4.51 4.51-3.34 3.33-4.5-4.51A5.68 5.68 0 000 5.89a5.89 5.89 0 005.89 5.89 5.73 5.73 0 001.82-.28l1.16 1.4 1.67 1.67 3 3.43M16.68 3h9.1v1.7h-8l5.02 5.06a1 1 0 001.42 0l1.56-1.58v2l-1.32 1.28a1.32 1.32 0 01-1.9 0l-5.67-5.9v7.77a.77.77 0 00.85.86h8v1.73h-9.1a1.62 1.62 0 01-1.49-1.51V4.48A1.62 1.62 0 0116.68 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/task-send.svg
// module id = KGlF
// module chunks = 1